import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function getListSim(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/sim/list-sim",
            API_BASE_URL + "/sim/list-sim",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.linea,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("getListSim err");
        console.log(err);
        return [];
    }
}

export async function createSim(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/sim/create-sim",
            API_BASE_URL + "/sim/create-sim",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createSim err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableSim(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/sim/disable-sim",
            API_BASE_URL + "/sim/disable-sim",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableSim err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableSim(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/sim/enable-sim",
            API_BASE_URL + "/sim/enable-sim",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enableSim err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updateSim(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/sim/update-sim",
            API_BASE_URL + "/sim/update-sim",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updateSim err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function getListSimCombo() {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/sim/list-sim-combo",
            API_BASE_URL + "/sim/list-sim-combo",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("getListSimCombo err");
        console.log(err);
        return [];
    }
}
